module.exports = __webpack_public_path__ + "static/media/4-2.abedda8a.webp";